import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from 'app/store'
import { License, getLicenseV1API } from 'api/licenseAPI'
import { getLicenseV2API, InvalidLicense, ValidLicense } from 'api/v2/licenseAPI'
import { RootState } from 'app/rootReducer'
import { convertArrayToObject } from 'utils/conver'

type Licenses = {
  [keyId: string]: License
}

type LicenseState = {
  isProcessing: boolean
  error: string
  license: License
  licenses: Licenses
  invalidLicenses: Licenses
  validLicenses: Licenses
}

const initialState: LicenseState = {
  isProcessing: true,
  error: '',
  licenses: {},
  invalidLicenses: {},
  validLicenses: {},
  license: {
    CreateDate: 0,
    ExpireDate: 0,
    MaxUsers: 0,
    keyId: '',
    CreateDateZh: '',
    SIPService: false,
    FeatureList: {
      MaxConferenceDuration: 0,
      MaxAttendees: 0,
      MaxHoldConferenceCounts: 0,
      Recording: true,
      AvailableRecordingMode: ['standard', 'moderator'],
      WebinarMode: false,
      MaxAudience: 0,
      MaxAudienceDuration: 0,
      ConferenceCall: false,
    },
  },
}

const licenseSlice = createSlice({
  name: 'license',
  initialState,
  reducers: {
    actionStart(state) {
      state.isProcessing = true
    },
    actionFailure(state, action: PayloadAction<string>) {
      state.isProcessing = false
      state.error = action.payload
    },
    actionSuccess(state, action: PayloadAction<License>) {
      state.isProcessing = false
      state.error = ''
      state.license = action.payload
    },
    setLicenses(
      state,
      action: PayloadAction<{ licenses: License[]; invalidLicenses: InvalidLicense[]; validLicenses: ValidLicense[] }>
    ) {
      const { licenses, invalidLicenses, validLicenses } = action.payload
      state.licenses = convertArrayToObject(licenses, 'keyId')
      const invalidL = Object.keys(convertArrayToObject(invalidLicenses, 'licenseKey'))
      const validL = Object.keys(convertArrayToObject(validLicenses, 'licenseKey'))

      state.invalidLicenses = invalidL.reduce(
        (obj, key) => {return {...obj, [key]: state.licenses[key]}},
        {}
      ) 
      state.validLicenses = validL.reduce(
        (obj, key) => {return {...obj, [key]: state.licenses[key]}},
        {}
      ) 
    },
  },
})

export const { actionStart, actionFailure, actionSuccess, setLicenses } = licenseSlice.actions

export const selectLicense = (state: RootState) => state.license.license

export const selectLicenses = (state: RootState) => {
  return {
    licenses: state.license.licenses,
    invalidLicenses: state.license.invalidLicenses,
    validLicenses: state.license.validLicenses,
  }
}

export const selectIsProcessing = (state: RootState) => state.license.isProcessing

export default licenseSlice.reducer

// Thunk start:
export const getLicenseV1Thunk = (): AppThunk => async (dispatch) => {
  dispatch(actionStart())
  try {
    dispatch(actionStart())
    const { data } = await getLicenseV1API()
    dispatch(actionSuccess(data))
  } catch (err) {
    dispatch(actionFailure(err.toString()))
    // TODO: handle fail flow
  }
}

// export const getLicenseV2Thunk = (): AppThunk => async (dispatch) => {
//   const {
//     data: { rawLicenses },
//   } = await getLicenseV2API()
//   const convertArrayToObject = (array: any[], key: string) => {
//     const initialValue = {}
//     return array.reduce((obj, item) => {
//       return {
//         ...obj,
//         [item[key]]: item,
//       }
//     }, initialValue)
//   }

//   const licenses = convertArrayToObject(rawLicenses, 'keyId')
//   dispatch(setLicenses(licenses))
// }
